// hooks/campaign/useCampaignLeave.js
import { useEffect } from 'react';

const useCampaignLeave = (userName, campaignId) => {
    useEffect(() => {
        const cleanup = () => {
            if (userName && campaignId) {
                navigator.sendBeacon('/api/presence/cleanup', 
                    JSON.stringify({ user_name: userName })
                );
            }
        };

        window.addEventListener('beforeunload', cleanup);
        document.addEventListener('visibilitychange', () => {
            if (document.hidden) cleanup();
        });

        return cleanup; // Cleanup on component unmount
    }, [userName, campaignId]);
};

export default useCampaignLeave;
